import styled from 'styled-components';

export const Title = styled.div`
  font-weight: 700;
  font-size: 24px;
  line-height: 36px;
`;
export const Description = styled.div`
  margin-top: 15px;
  font-weight: 400;
  font-size: 16px;
  line-height: 25px;
`;

const Wrapper = styled.div`
  margin-top: 70px;
  display: flex;
  align-items: end;
  justify-content: space-between;
`;

export default Wrapper;
